export enum StepType {
  PY,
  ENGINE,
  TRIGGER,
  ENGINE_TRIGGER,
}
